import React, { useState } from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import PropTypes from 'prop-types';
import './GovBrAccordion.css';

export function GovBrAccordion({ name, total, content }) {
  const [isTabOpen, setIsTabOpen] = useState(false);

  return (
    <>
      <div className="accordionTitle">
        <button
          className="dropdownTitleButton"
          onClick={() => setIsTabOpen(!isTabOpen)}
        >
          {isTabOpen ? (
            <FaChevronUp className="templateTab-angleIcon" />
          ) : (
            <FaChevronDown className="templateTab-angleIcon" />
          )}
          <p className="dropdownTitle">{name}</p>
          <strong className="radius">{total}</strong>
        </button>
      </div>
      {isTabOpen && <div className="accordionContent">{content}</div>}
    </>
  );
}

GovBrAccordion.propTypes = {
  name: PropTypes.string.isRequired,
  total: PropTypes.number,
  content: PropTypes.element,
};

GovBrAccordion.defaultProps = {
  content: <></>,
  total: 0,
};
